import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingHeaderBrokerButton } from '../../components/NewbuildingHeaderBrokerButton';
import { useBrokerLinks } from '../../hooks/useBrokerLinks';
import { useNewbuildingBrokerAnalyticsUser } from '../../hooks/useNewbuildingBrokerAnalyticsUser';
import { getJsonQuery } from '../../selectors/getJsonQuery';
import {
  getIsSnippetBrokerVisible,
  getSnippetBrokerButtonShouldRedirect,
  getSnippetNewbuildingBrokerParams,
} from '../../selectors/newbuildingBroker';
import { getNewbuildingId } from '../../selectors/newbuildingHeader';
import { trackSellApartmentClick } from '../../tracking/newbuilding/broker';
import { NewbuildingBrokerWidgetContext } from '../NewbuildingBrokerWidgetProvider';

export const NewbuildingHeaderBrokerButtonContainer: React.FC = () => {
  const newbuildingId = useSelector(getNewbuildingId) ?? null;
  const { landingPageLink } = useBrokerLinks();
  const jsonQuery = useSelector(getJsonQuery);
  const snippetBrokerButtonShouldRedirect = useSelector(getSnippetBrokerButtonShouldRedirect);
  const user = useNewbuildingBrokerAnalyticsUser();
  const isSnippetBrokerButtonVisible = useSelector(getIsSnippetBrokerVisible);
  const brokerWidgetParams = useSelector(getSnippetNewbuildingBrokerParams);
  const buttonText = brokerWidgetParams ? 'Провести сделку' : 'Заработать комиссию';

  const openWidget = React.useContext(NewbuildingBrokerWidgetContext);

  const [loading, setLoading] = React.useState(false);

  const openLandingOrWidget = React.useCallback(async () => {
    setLoading(true);

    if (snippetBrokerButtonShouldRedirect) {
      window.open(landingPageLink, '_blank', 'noopener');
    } else {
      if (brokerWidgetParams) {
        const { accountLegalType, hasConfirmedPhone } = brokerWidgetParams;

        await openWidget({
          accountLegalType,
          hasConfirmedPhone,
          newbuildingId,
        });
      }
    }

    setLoading(false);
  }, [brokerWidgetParams, landingPageLink, newbuildingId, openWidget, snippetBrokerButtonShouldRedirect]);

  const handleButtonClick = React.useCallback(async () => {
    trackSellApartmentClick(jsonQuery, user, true);
    await openLandingOrWidget();
  }, [openLandingOrWidget, jsonQuery, user]);

  if (!isSnippetBrokerButtonVisible) {
    return null;
  }

  return <NewbuildingHeaderBrokerButton loading={loading} onClick={handleButtonClick} buttonText={buttonText} />;
};
